import { EventEmitter, inject, Injectable } from "@angular/core";
import { FirebaseAuthService } from "./firebase/firebase-auth.service";
import {
  MESSAGE,
} from "../../../../commondata/messages/msg-constants";
import {
  AuthenticationService,
  Credentials,
} from "./authentication/authentication.service";
import { InitialStateDto } from "../../../../commondata/messages/initial-state-dto";
import { Router } from "@angular/router";
import {
  CredentialsMissingMessage,
  CredentialsResponseMessage,
  ShellMessage,
  UserLoggedOutMessage,
} from "../../../../commondata/messages/messages-dto";
import { UrlService } from "./url.service";
import { ModuleStateService } from "../module-state.service";
import { LoaderService } from "../shared/loader/loader.service";
import { User } from "firebase/auth";
import { ThemeManagerService } from "../theme-manager.service";
import { AccessConfigService } from "../access-config/access-config.service";

@Injectable({
  providedIn: "root",
})
export class ModuleMessageService {
  private firebaseAuthService = inject(FirebaseAuthService);
  private authenticationService = inject(AuthenticationService);
  private locationHistoryService = inject(UrlService);
  private themeManagerService = inject(ThemeManagerService);
  private accessConfigService = inject(AccessConfigService);
  private router = inject(Router);
  private moduleId = "";
  private landingUrl = "";

  private shellCredentials: any;
  private shellfbCredentials: any;
  private shelltoken: any;
  private useHistory: boolean = false;

  userInitialized = false;
  credentialmissing = false;
  public isAuthenticationChanged = new EventEmitter<Credentials>();

  constructor(
    private moduleStateService: ModuleStateService,
    private loaderService: LoaderService
  ) { }

  public initialize(
    moduleId: string,
    landingUrl: string,
    useHistory: boolean = false
  ) {
    this.moduleId = moduleId;
    this.landingUrl = landingUrl;
    this.useHistory = useHistory;
  }

  handleMessage(event: MessageEvent) {
    const eventData = event.data as unknown as ShellMessage;
    switch (eventData.msgType) {
      case MESSAGE.MSGTYPE.CREDENTIAL_RESPONSE:
        // Credenziali ricevute
        const msg = event.data as unknown as CredentialsResponseMessage;
        this.shellCredentials = msg.msgData.credentials;
        this.shellfbCredentials = msg.msgData.fbcredentials;
        this.shelltoken = msg.msgData.token;
        const cr = this.firebaseAuthService.getCurrentFirebaseUserEmail(); // this.firebaseAuthService.getFirebaseUser(); // this.authenticationService.credentials;
        const forcelogin = cr !== JSON.parse(this.shellCredentials).username; //this.shellCredentials;
        if (forcelogin) {
          this.authenticationService.setCredentials(
            JSON.parse(this.shellCredentials)
          );
        }
        this.reloadCredentials(forcelogin)
          .then((cred: User | null) => {
            this.authenticationService.reloadCredentials();
            localStorage.setItem("fbcredentials", this.shellfbCredentials);
            localStorage.setItem("token", this.shelltoken);
            // let url = location.pathname;
            let url: string = this.moduleStateService.gotoRootPageByRole(
              this.authenticationService.credentials?.role || "",
              this.moduleStateService.path
            );
            if (cred?.displayName === "") {
              const msg = new CredentialsMissingMessage(
                this.moduleStateService.guid,
                { createCustomToken: true }
              );
              this.sendMessage(msg);
            } else {
              if (url === "/") {
                if (this.useHistory) {
                  const oldUrl = this.locationHistoryService.getCurrentUrl();
                  if (oldUrl && !oldUrl.includes("login")) {
                    url = oldUrl.split("?")[0] + oldUrl;
                  } else {
                    url = this.landingUrl;
                  }
                } else {
                  url = this.landingUrl;
                }
              }
              this.moduleStateService.startFromRoot.set(url === '/admin-page');
              console.log("***NAVIGATE TO: " + url);
              this.loaderService.stopLoading('generic');
              this.router.navigate([url], { replaceUrl: true });
            }
          })
          .catch((error) => {
            const msg = new CredentialsMissingMessage(this.moduleId, {
              createCustomToken: true,
            });
            this.sendMessage(msg);
            this.loaderService.stopLoading('generic');
          });
        break;

      case MESSAGE.MSGTYPE.RESPONSE_CREDENTIALS_SIMPLE:
        // Credenziali ricevute
        if (!event.data.msgData) {
          const url: string = this.moduleStateService.gotoRootPageByRole(
            this.authenticationService.credentials?.role || "",
            this.moduleStateService.path
          );
          this.router.navigate([url], { replaceUrl: true });
        } else {
          const msg2 = event.data as unknown as CredentialsResponseMessage;
          this.shellCredentials = msg2.msgData.credentials;
          this.shellfbCredentials = msg2.msgData.fbcredentials;
          this.shelltoken = msg2.msgData.token;
          this.reloadCredentials(true)
            .then((cred: User | null) => {
              this.authenticationService.reloadCredentials();
              localStorage.setItem("fbcredentials", this.shellfbCredentials);
              localStorage.setItem("token", this.shelltoken);
              this.moduleStateService.onSimpleCredentialsLoaded.emit();
            });
        }
        break;

      case MESSAGE.MSGTYPE.CREDENTIAL_CHANGED:
        const cred = eventData.msgData as Credentials;
        this.authenticationService.setCredentials(cred);
        this.isAuthenticationChanged.emit(cred);

        break;
      case MESSAGE.MSGTYPE.USER_LOGOUT:
        this.authenticationService.logout().subscribe(() => {
          this.loaderService.stopLoading('generic');
          const msglogout = new UserLoggedOutMessage(this.moduleId, {});
          this.sendMessage(msglogout);
        });
        break;
      case MESSAGE.MSGTYPE.SET_INITIAL_STATE:
        const state = (eventData.msgData.state as InitialStateDto);
        this.themeManagerService.toggleTheme(eventData.msgData.state.theme);


        break;
      case MESSAGE.MSGTYPE.NOTIFY_TARGET_DOC:
        // console.log('NOTIFY_TARGET_DOC: ' + JSON.stringify(eventData.msgData));
        this.moduleStateService.sideDocInfo = eventData.msgData;
        break;
    }
  }

  reloadCredentials(forcelogin: boolean): Promise<User | null> {
    // Ricarica credenziali
    return new Promise((resolve, reject) => {
      // const credentials = localStorage.getItem("credentials");
      const user = this.firebaseAuthService.currentUser;
      Promise.resolve()
        .then(() => {
          if (forcelogin && this.firebaseAuthService.currentUser !== null) {
            return this.firebaseAuthService.logoutPromise();
          } else {
            return Promise.resolve();
          }
        })
        .then(() => {
          const user = this.firebaseAuthService.currentUser;
          if (forcelogin || this.firebaseAuthService.currentUser === null) {
            const customToken =
              this.authenticationService?.credentials?.customToken || "";
            if (customToken) {
              return this.firebaseAuthService.signInCustomToken(customToken);
            } else {
              return this.firebaseAuthService.getCurrentFirebaseUser();
            }
          } else {
            return this.firebaseAuthService.getCurrentFirebaseUser();
          }
        })
        .then((cred: User | null) => {
          this.userInitialized = true;
          return resolve(cred);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  }

  public sendMessage(message: any) {
    (window as any).top.postMessage(message, "*");
  }
}
